module.exports = __webpack_public_path__ + "static/logistics-tracking-notification-bded46ccf8a504b2ceca834452aed496.png";